if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.dispatchEvent(new Event("submitting"));

        this.handleErrorMessage();

        /* Keep here or else if click 'back' page 'stuck' in loading state */
        if (theme && theme.browserSupports && !theme.browserSupports.cookiesSetWithFetch) {
          console.log('Legacy browser: Submit whole product form without fetch to ensure cookies set correctly');
          this.form.submit();
          return;
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const productVariantId = FormData.prototype.get ? formData.get('id') : this.form.querySelector('input[name="id"]').value;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: productVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: productVariantId });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );

  (function (munchables) {
    var createElement = function createElement(nodeName, props) {
      /*
       * Hack to remove sperad operator to support older browsers. Equivalent to:
       * const { style = {}, attributes = {}, ...propsNoStyle } = props;
       */
      const propCopy = Object.assign({}, props || {});

      const style = propCopy.style || {};
      delete propCopy.style

      const attributes = propCopy.attributes || {};
      delete propCopy.attributes

      const propsNoStyle = propCopy

      const element = Object.assign(document.createElement(nodeName), propsNoStyle);

      Object.entries(style).forEach(([key, value]) => { element.style[key] = value; });
      Object.entries(attributes).forEach(([key, value]) => { element.setAttribute(key, value); });

      return element;
    };

    class ButtonPicker {
      constructor(pickerConfig, globalConfig) {
        this.config = pickerConfig;
        this.global = globalConfig;
      }

      createPicker(creationConfig) {
        var bulkSelector = createElement('fieldset', {
          className: "js product-form__input " + this.global.css.inputWrapper.name + " motion-reduce"
        });

        bulkSelector.append(Object.assign(document.createElement('legend'), { className: "form__label", textContent: `${this.global.text.optionName} ${creationConfig.number}` }));
        bulkSelector.append(...this.createColorOptions(creationConfig.number, creationConfig.options));

        return bulkSelector;
      }

      createColorOptions(number, options) {
        var buttonAndLabels = [];

        var isRadioGroupValidating = false;
        (options || []).forEach((o, index) => {
          var optionSuffix = o.available ? "" : ` (${this.global.text.soldOut})`;
          var radioGroupName = `${this.global.css.inputWrapper.name}-color-${number}`;
          var radioId = `${this.global.elementIdPrefix}-${this.global.css.inputWrapper.name}-color-${number}-${index}`;
          var radioButton = createElement('input', {
            id: radioId,
            type: 'radio',
            value: o.name,
            required: true,
            disabled: !o.available,
            attributes: {
              name: radioGroupName,
              form: this.global.productFormId
            }
          });

          radioButton.addEventListener("invalid", () => {
            isRadioGroupValidating = true;
          });
          radioButton.addEventListener("focusout", () => {
            isRadioGroupValidating = false;
          });
          radioButton.addEventListener("focus", (evt) => {
            setTimeout(() => {
              if (document.activeElement === evt.target && !evt.target.checked && !isRadioGroupValidating) {
                evt.target.click();
              }
            });
          });

          // NOTE: if change the array position of this, then update 'refreshColorPickers'
          buttonAndLabels.push(radioButton, createElement('label', {
            attributes: {
              for: radioId
            },
            textContent: o.name + optionSuffix
          }));
        });

        return buttonAndLabels;
      }

      refreshColorPickers(wrapperElements, options) {
        wrapperElements.forEach((element, index) => {
          var currentValue = this.getValueFrom(element);
          var label = element.querySelector("legend").textContent;

          while (element.firstChild) {
            element.removeChild(element.firstChild);
          };

          var newOptions = [Object.assign(document.createElement('legend'), { className: "form__label", textContent: label }), ...this.createColorOptions(index + 1, options)];
          newOptions.forEach(item => element.appendChild(item));

          this.setValue(element, currentValue);
        });
      };

      // Assume this can work for either the bulk selector color pickers, or the actual original color picker containing 'set of X'
      getValueFrom(wrapperElement) {
        var radioButton = wrapperElement.querySelector('input[type="radio"]:checked')
        return radioButton ? radioButton.value : null;
      }

      setValue(wrapperElement, newValue) {
        var item = wrapperElement.querySelector(`input[type="radio"][value="${newValue}"]`);

        if (item && !item.disabled) {
          item.checked = true;
        } else {
          wrapperElement.querySelectorAll('input[type="radio"]').forEach((element) => element.checked = false);
        }
      }
    }

    class DropdownPicker {
      constructor(pickerConfig, globalConfig) {
        this.config = pickerConfig;
        this.global = globalConfig;
      }

      createPicker(creationConfig) {
        var bulkSelector = createElement('div', {
          className: "product-form__input product-form__input--dropdown " + this.global.css.inputWrapper.name + " motion-reduce"
        });

        var selectWrapper = Object.assign(document.createElement('div'), { className: "select" })

        bulkSelector.appendChild(selectWrapper)
          .appendChild(createElement('select', {
            className: "select__select",
            required: true,
            attributes: { form: this.global.productFormId }
          }))
          .append(Object.assign(document.createElement('option'), {
            value: "",
            textContent: `${this.global.text.optionName} ${creationConfig.number}`
          }), ...this.createColorOptions(creationConfig.options));

        if (this.config && this.config.iconHtml) {
          let temp = document.createElement('div');
          temp.innerHTML = this.config.iconHtml;
          selectWrapper.appendChild(temp.firstChild);
        }

        return bulkSelector;
      }

      createColorOptions(options) {
        return (options || []).map((o) => {
          var optionSuffix = o.available ? "" : ` (${this.global.text.soldOut})`;

          return Object.assign(document.createElement('option'), {
            value: o.name,
            disabled: !o.available,
            textContent: o.name + optionSuffix
          });
        });
      }

      refreshColorPickers(wrapperElements, options) {
        wrapperElements.forEach((element, index) => {
          var select = element.querySelector("select");
          var currentValue = select.value || "";
          var label = select.querySelector("option[value='']").textContent;

          while (select.firstChild) {
            select.removeChild(select.firstChild);
          };

          var newOptions = [Object.assign(document.createElement('option'), {
            value: "",
            textContent: label
          }), ...this.createColorOptions(options)];
          newOptions.forEach(item => select.appendChild(item));

          this.__setSelectValue(select, currentValue);
        });
      };

      // Assume this can work for either the bulk selector color pickers, or the actual original color picker containing 'set of X'
      getValueFrom(wrapperElement) {
        return wrapperElement.querySelector("select").value;
      }

      setValue(wrapperElement, newValue) {
        this.__setSelectValue(wrapperElement.querySelector("select"), newValue);
      }

      __setSelectValue(select, newValue) {
        const optionElement = select.querySelector(`option[value="${newValue}"]`);

        if (optionElement && optionElement.disabled) {
          newValue = "";
        }

        select.value = newValue;

        // Don't remove the "" check... when assigning an invalid value the select.value becomes empty,
        // but doesn't actually pick the 'Color #' option which has a value of "", so weird... forcing it again seems to work!
        if (select.value === null || select.value === "")
          select.value = ""; // Show the 'Color #' option, don't assume
      }
    }

    munchables.BulkOptionManager = function (args) {
      var self = this;
      var productFormId = args.productFormId;
      var formSelector = args.formSelector;
      var productData = args.productData;
      var variantConfig = args.variantConfig;
      const coreOptionPickers = args.coreOptionPickers;
      const container = args.container;
      const elementIdPrefix = args.elementIdPrefix;
      const colorOptionNames = args.optionNames;
      const urlColorParamName = "colors";

      const css = {
        inputWrapper: {
          name: "selector-bulk",
          selector: ".selector-bulk"
        }
      }
      css.inputWrapperRemoving = {
        name: css.inputWrapper.name + "-removing",
        selector: "." + css.inputWrapper.name + "-removing"
      }

      self.css = css;

      const animations = {
        style: {
          add: theme.animations.fadeInDown,
          remove: theme.animations.fadeOutUp,
        }
      };

      const pickerUIGlobalConfig = {
        css: css,
        productFormId: productFormId,
        elementIdPrefix: elementIdPrefix,
        text: args.text
      };
      const pickerConfig = {
        'button': () => new ButtonPicker(variantConfig.picker, pickerUIGlobalConfig),
        'dropdown': () => new DropdownPicker(variantConfig.picker, pickerUIGlobalConfig)
      }

      const pickerUI = pickerConfig[variantConfig.picker.type] ? pickerConfig[variantConfig.picker.type]() : pickerConfig['dropdown']();

      self.useDefaultColors = true;

      self.getDefaultVariantColors = function () {
        var vParams = self.getUrlParams();
        return vParams[urlColorParamName] ? self.expandCompactColors(vParams[urlColorParamName]) : [];
      }

      self.expandCompactColors = function (str) {
        if (!str) return [];

        var colors = [];
        var parts = str.split(",");

        for (var i = 0; i < parts.length; ++i) {
          var colorPart = (parts[i] || "").trim();
          var numberSplitIndex = colorPart.indexOf(" ");
          var isNumbered = false;
          if (numberSplitIndex > 0) {
            var number = Number(colorPart.substring(0, numberSplitIndex));
            if (number >= 0) {
              var optionValue = colorPart.substring(numberSplitIndex + 1);
              for (var j = 0; j < number; ++j)
                colors.push(optionValue);

              isNumbered = true;
            }
          }

          if (!isNumbered)
            colors.push(colorPart);
        }

        return colors;
      }

      self.compactColorList = function (colors, delim) {
        if (!colors || colors.length === 0) return "";

        const colorList = [];
        const colorCounts = {};

        for (var i = 0; i < colors.length; ++i) {
          if (colors[i]) {
            colorCounts[colors[i]] = (colorCounts[colors[i]] || 0) + 1;
          };
        }

        for (const [key, value] of Object.entries(colorCounts)) {
          if (value > 1) {
            colorList.push(value + " " + key);
          } else {
            colorList.push(key);
          }
        }

        return colorList.join(delim || ',');
      }

      self.getUrlParams = function () {
        var match,
          pl = /\+/g,  // Regex for replacing addition symbol with a space
          search = /([^&=]+)=?([^&]*)/g,
          decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
          query = window.location.search.substring(1);

        urlParams = {};
        while (match = search.exec(query))
          urlParams[decode(match[1])] = decode(match[2]);

        return urlParams;
      }

      self.getColorOptionIndex = function () {
        var colorIndex = -1;
        var colorProperties = colorOptionNames;
        productData.options.forEach((item, index) => {
          if (colorProperties.indexOf(item.toLowerCase()) > -1) {
            colorIndex = index;
          }
        });

        return colorIndex;
      };

      self.getColorsFromSelectedOptions = function () {
        var colorIndex = self.getColorOptionIndex();
        var colors = [];

        if (colorIndex > -1) {
          var nonColorOptionIndexes = productData.options.map((item, index) => index).filter(optionIndex => optionIndex !== colorIndex);
          var nonColorSelection = nonColorOptionIndexes.map(nonColorIndex => pickerUI.getValueFrom(coreOptionPickers[nonColorIndex])).join(",");

          // Only grab colors that match options selected by user -- exclude 'set of X' options
          for (var i = 0; i < productData.variants.length; ++i) {
            var v = productData.variants[i];
            var nonColorData = nonColorOptionIndexes.map(nonColorIndex => v.options[nonColorIndex]).join(",");

            if (nonColorData === nonColorSelection && ((variantConfig[v.id] || {}).setOf || 1) <= 1) {
              colors.push({
                name: v.options[colorIndex],
                available: v.available
              });
            }
          }
        }

        return colors;
      }

      self.refreshColorPickers = function (colors) {
        pickerUI.refreshColorPickers(self.__getOptionPickers(), colors);
      };

      self.configureFor = function (vArgs) {
        const variant = vArgs.variant;
        var variantOptions = variantConfig[(variant || {}).id] || {};
        var showBulkSelector = false;
        var defaultColors = [];
        const reducedMotion = theme.animations.isReducedMotion();

        var pickerAboutToAppear = (picker) => {
          picker.classList.add(animations.style.add);

          theme.animations.onAnimationEndOrTimeout({
            element: picker,
            action: (target) => target.classList.remove(animations.style.add),
            timeout: 500
          });
        }

        var removePicker = (picker) => {
          if (reducedMotion) {
            picker.remove();
          }
          else {
            picker.classList.add(css.inputWrapperRemoving.name);
            // removing 'selector-bulk' prevents removing inputs want to keep
            picker.classList.remove(css.inputWrapper.name, animations.style.add);
            picker.classList.add(animations.style.remove);

            theme.animations.onAnimationEndOrTimeout({
              element: picker,
              action: (target) => target.remove(),
              timeout: 500
            });
          }
        };

        if (self.useDefaultColors) {
          self.useDefaultColors = false;

          if (vArgs.selectedColors && vArgs.selectedColors.length > 0) {
            defaultColors = vArgs.selectedColors;
          }
          else {
            defaultColors = self.getDefaultVariantColors();
          }
        }

        if (variantOptions.setOf > 1) {
          showBulkSelector = true;
        }

        var colorIndex = self.getColorOptionIndex();
        var colorSelector = colorIndex > -1 ? coreOptionPickers[colorIndex] : null;

        if (showBulkSelector && colorSelector) {
          var injectionPoint = self.__getOptionPickers();

          if (injectionPoint.length === 0) {
            injectionPoint = colorSelector;
          } else {
            injectionPoint = injectionPoint[injectionPoint.length - 1];
          }

          var additionalColorPickers = [];

          var previousSetSize = Number(colorSelector.dataset.setOf) || 0;
          var colorSetSize = variantConfig[variant.id].setOf;
          var requiredElements = colorSetSize - previousSetSize;

          var startingColorNumber = 1;

          if (requiredElements < 0) {
            var displayedPickers = self.__getOptionPickers();
            for (var i = colorSetSize; i < displayedPickers.length; ++i) {
              removePicker(displayedPickers[i]);
            }
          } else {
            var availableColors = self.getColorsFromSelectedOptions();

            if (previousSetSize > 0) {
              startingColorNumber = previousSetSize + 1;
              self.refreshColorPickers(availableColors);
            }

            for (var i = startingColorNumber; i <= colorSetSize; ++i) {
              additionalColorPickers.push(pickerUI.createPicker({ number: i, options: availableColors }));
            }
          }

          colorSelector.dataset.setOf = colorSetSize;

          if (additionalColorPickers.length > 0) {
            if (defaultColors.length > 0) {
              additionalColorPickers.forEach((item, index) => {
                if (index < defaultColors.length) {
                  pickerUI.setValue(item, defaultColors[index] || "");
                }
              });
            }

            additionalColorPickers.forEach(item => {
              pickerAboutToAppear(item);
            });
            injectionPoint.after(...additionalColorPickers);
          }
        } else {
          self.__getOptionPickers().forEach(bulkSelector => {
            removePicker(bulkSelector);
          });

          delete colorSelector.dataset.setOf;
        }

        self.updateState(showBulkSelector ? self.getSelectedColors() : []);
      };

      self.getSelectedColors = function () {
        return Array.from(self.__getOptionPickers()).map(picker => pickerUI.getValueFrom(picker));
      };

      self.__getOptionPickers = function () {
        return container.querySelectorAll(css.inputWrapper.selector);
      };

      self.updateState = function (colorsSelected) {
        // urlColorParamName sticking because this happens after variant-select/radio adds the variant id
        if (variantConfig.updateUrl && window.history && window.history.replaceState) {
          var newState = window.history.state || {};
          var currentQueryState = self.getUrlParams();

          newState[urlColorParamName] = self.compactColorList(colorsSelected, ',');
          currentQueryState[urlColorParamName] = newState[urlColorParamName];

          if (!newState[urlColorParamName]) {
            delete newState[urlColorParamName];
            delete currentQueryState[urlColorParamName];
          }

          // NOTE: Arrays will be converted to CSV rather than name[]=val1&name[]=val2...
          const p = new URLSearchParams(currentQueryState);
          newQueryString = p.toString().replace(/\%2C/g, ",");

          if (newQueryString)
            newQueryString = "?" + newQueryString;

          window.history.replaceState(newState, "", location.protocol + "//" + location.host + location.pathname + newQueryString + location.hash);
        }
      };

      self.__onFormSubmit = function () {
        var form = container.querySelector(formSelector);
        var submitBulkOptionId = elementIdPrefix + "-bulkColors";
        var field = form.querySelector("#" + submitBulkOptionId);

        var colorsSelected = self.getSelectedColors();
        var colorSummary = self.compactColorList(colorsSelected, ', ');

        if (colorSummary) {
          if (field === null) {
            field = Object.assign(document.createElement('input'), {
              type: "hidden",
              id: submitBulkOptionId,
              name: "properties[Colors]"
            });
            form.appendChild(field);
          }

          field.value = self.compactColorList(colorsSelected, ', ');
        } else if (field) {
          field.remove(); // Prevent shopify from displaying a blank custom property
        }

        self.updateState(colorsSelected);
      }

      self.init = function (args) {
        container.querySelector("product-form").addEventListener('submitting', self.__onFormSubmit);

        const form = document.getElementById(productFormId);
        form.noValidate = false;

        const isBulkOptionPicker = (e) => e.closest(css.inputWrapper.selector + "," + css.inputWrapperRemoving.selector) !== null;
        args.variantControl.setOptionPickerFilter(e => !isBulkOptionPicker(e));
        args.variantControl.addEventListener('change', function (evt) {
          if (isBulkOptionPicker(evt.target)) {
            self.updateState(self.getSelectedColors());
          } else {
            self.configureFor({ variant: this.currentVariant });
          }
        });

        const bulkVariantConfig = {
          variant: productData.variants.find((v) => v.id === args.currentVariantId)
        };

        const currentVariantHasSetOf = (variantConfig[args.currentVariantId] || {}).setOf > 1;

        if (currentVariantHasSetOf) {
          // Must force internal state update or else change event has no currentVariant!
          bulkVariantConfig.selectedColors = self.getDefaultVariantColors();
          args.variantControl.syncVariantState(); // wipes out the color from url
          bulkVariantConfig.variant = args.variantControl.currentVariant; // may no longer be selected/first variant
        }

        self.configureFor(bulkVariantConfig);
      }
    };
  })(window.munchables = window.munchables || {});
}
